// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import React from 'react';

export default function CloseIcon() {
  return (
    // <svg
    //     width="22"
    //     height="22"
    //     viewBox="0 0 22 22"
    //     fill="none"
    //     className="fill-current"
    //     xmlns="http://www.w3.org/2000/svg"
    // >
    //     <path
    //         d="M0 11C0 4.92487 4.92487 0 11 0V0C17.0751 0 22 4.92487 22 11V11C22 17.0751 17.0751 22 11 22V22C4.92487 22 0 17.0751 0 11V11Z"
    //         fill="white"
    //     />
    //     <path
    //         fillRule="evenodd"
    //         clipRule="evenodd"
    //         d="M1 11C1 16.5228 5.47715 21 11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11ZM11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0Z"
    //         className="fill-current"
    //     />
    //     <path
    //         d="M10 6C10 5.44772 10.4477 5 11 5V5C11.5523 5 12 5.44772 12 6V16C12 16.5523 11.5523 17 11 17V17C10.4477 17 10 16.5523 10 16V6Z"
    //         className="fill-current"
    //     />
    //     <path
    //         d="M16 10C16.5523 10 17 10.4477 17 11V11C17 11.5523 16.5523 12 16 12L6 12C5.44772 12 5 11.5523 5 11V11C5 10.4477 5.44772 10 6 10L16 10Z"
    //         className="fill-current"
    //     />
    // </svg>
    <svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-7" viewBox="0 0 20 20" fill="currentColor">
      <path
        fillRule="evenodd"
        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
        clipRule="evenodd"
      />
    </svg>
  );
}
